import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { Title } from "@src/appV2/redesign/components/Title";
import SvgCheck from "@src/appV2/redesign/assets/illustrations/Check";

export function MobileCreateCaseSuccess() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={3} sx={{ flex: 1, px: 3 }}>
      <SvgCheck />
      <Title component="h5" sx={{ fontWeight: "bold" }}>
        Visit posted
      </Title>
      <Text variant="body1" sx={{ textAlign: "center" }}>
        We&apos;re sharing your case with local professionals!
      </Text>
    </Stack>
  );
}
